const HeroInformation = () => <div>HeroInfo UIKIT Migration</div>

export default HeroInformation